import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef } from "react";
// @mui
import { Section } from "@arp/react-ndbx";

import FadeInOut from "../utilities/fadeInOut";

// ----------------------------------------------------------------------

const Page = forwardRef(
  ({ children, title = "", identifier = "", meta, ...other }, ref) => (
    <>
      <Helmet>
        <title>{`${title} | Allianz Term Life`}</title>
        {meta}
        <script src={import.meta.env.VITE_ADOBE_DTM} async></script>
      </Helmet>

      <FadeInOut show={1 === 1} duration={500} style={{ width: "100%" }}>
        <Section data-identifier={identifier} ref={ref} {...other}>
          {children}
        </Section>
      </FadeInOut>
    </>
  )
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
